import React, { useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import ReportAdModal from "./ReportAdModal";
import AdPreferenceModal from "./AdPreferenceModal";
import { trackAdEvent } from "../../hook/useAdsApi";

// 3-dot menu for a sponsored ad card. Self-contained so any ad card can drop it in without
// wiring its own dropdown/modal state - stopPropagation keeps it from triggering the card's
// own click/navigation handler.
// `onHideAd` is optional: called after a successful "Hide this ad" so the caller can drop the
// ad from whatever list/hook state is currently rendering it (e.g. useSponsoredAds's removeAd).
export default function AdOptionsMenu({
  ad,
  className = "top-2 left-2",
  dropdownClassName = "left-0 mt-1",
  onHideAd,
}) {
  const [open, setOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [hideOpen, setHideOpen] = useState(false);
  const [hideSimilarOpen, setHideSimilarOpen] = useState(false);

  const adId = ad?.id;
  if (!adId) return null;

  // Hides/reports also go to the delivery event log (once per impression), which feeds the
  // ad's negative-feedback quality signal. Only ads rendered from an auction have a trackingId.
  const recordEvent = (eventType) => {
    if (ad.trackingId) trackAdEvent({ tracking_id: ad.trackingId, event_type: eventType }).catch(() => {});
  };
  const handleHidden = () => {
    recordEvent("hide");
    onHideAd?.();
  };

  return (
    <div className={`absolute ${className} z-10`} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="w-6 h-6 flex items-center justify-center rounded-full bg-white/90 text-gray-700 shadow"
        aria-label="Ad options"
      >
        <BsThreeDotsVertical size={14} />
      </button>
      {open && (
        <div className={`absolute ${dropdownClassName} bg-white shadow-md rounded-md w-40 py-1 text-sm`}>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              setReportOpen(true);
            }}
            className="block w-full text-left px-3 py-2 hover:bg-gray-100"
          >
            Report Ad
          </button>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              setHideOpen(true);
            }}
            className="block w-full text-left px-3 py-2 hover:bg-gray-100"
          >
            Hide this ad
          </button>
          <button
            type="button"
            onClick={() => {
              setOpen(false);
              setHideSimilarOpen(true);
            }}
            className="block w-full text-left px-3 py-2 hover:bg-gray-100"
          >
            Hide similar ads
          </button>
        </div>
      )}
      <ReportAdModal
        isOpen={reportOpen}
        onClose={() => setReportOpen(false)}
        adId={adId}
        onSuccess={() => recordEvent("report")}
      />
      <AdPreferenceModal
        isOpen={hideOpen}
        onClose={() => setHideOpen(false)}
        mode="hide"
        ad={ad}
        onSuccess={handleHidden}
      />
      <AdPreferenceModal
        isOpen={hideSimilarOpen}
        onClose={() => setHideSimilarOpen(false)}
        mode="hide-similar"
        ad={ad}
        onSuccess={handleHidden}
      />
    </div>
  );
}
